import React from "react";
import { Modal, Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalWrapperProps {
  open: boolean;
  onClose: () => void;
  header?: React.ReactNode;
  body?: React.ReactNode;
  footer?: React.ReactNode;
  styles?: React.CSSProperties;
}

const ModalWrapper: React.FC<ModalWrapperProps> = ({
  open,
  onClose,
  header,
  body,
  footer,
  styles,
}) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxWidth: "90vw",
          boxSizing: "border-box",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          ...styles,
        }}
      >
        <Box display="flex" justifyContent="center" alignItems="center">
          {header || <Typography variant="h6">Modal Header</Typography>}
          {/* <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton> */}
        </Box>

        <Box mt={2}>{body || <Typography>Modal Content</Typography>}</Box>
        {footer && <Box mt={2} display="flex" justifyContent="center" alignItems="center" gap={5}>{footer}</Box>}
      </Box>
    </Modal>
  );
};

export default ModalWrapper;
